var map = {
	"./auth.js": 2661,
	"./authfack.js": 7011,
	"./brand.js": 9194,
	"./layout.js": 7581,
	"./lifestyle.js": 6368,
	"./polyclinics.js": 104,
	"./spots.js": 182
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 634;